module.exports = __webpack_public_path__ + "img/2.9d05251c.png";